/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon16Regular = forwardRef('SendPaperplaneDiagIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.24 7.609c-1.03-.705-.8-2.287.39-2.667l11.084-3.544c1.16-.37 2.256.725 1.885 1.886l-3.543 11.083c-.38 1.19-1.963 1.42-2.667.39l-2.904-4.245L1.24 7.609Zm5.755 2.454 2.632 3.848L13.17 2.827 2.087 6.371l3.848 2.631L8.46 6.477a.75.75 0 0 1 1.06 1.06l-2.525 2.526Z" })));
});
